/**
 * ui/styles/poster.ts
 *
 * Poster-style finish for the plain buttons and fields that pages style
 * themselves. Include it after the page's own styles: it only sets border
 * width, hard shadow, press motion and type, so the page keeps its layout
 * and colors, and a page's class selectors still win over these.
 */
import { css } from 'lit';

export const posterControls = css`
  button,
  a.button {
    border-width: 2px;
    border-style: solid;
    box-shadow: 3px 3px 0 var(--color-drop);
    font-weight: var(--font-weight-bold);
    text-transform: uppercase;
    letter-spacing: 0.03em;
    transition: transform var(--transition-fast), box-shadow var(--transition-fast);
  }

  button:active:not(:disabled),
  a.button:active {
    transform: translate(3px, 3px);
    box-shadow: none;
  }

  button:disabled {
    box-shadow: none;
  }

  input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='color']),
  select,
  textarea {
    border-width: 2px;
    border-style: solid;
    border-color: var(--color-edge);
    background: var(--color-surface);
    color: var(--color-text);
  }

  input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='color']):focus,
  select:focus,
  textarea:focus {
    outline: none;
    box-shadow: 3px 3px 0 var(--color-blue);
  }

  input[type='checkbox'],
  input[type='radio'],
  input[type='range'] {
    accent-color: var(--color-text);
  }
`;
